import moment from 'moment'
import DatePickerCustom from '../../DatePicker/DatePickerCustom'
import objectPath from 'object-path'
import { useMemo } from 'react'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import { checkLockMode } from '../action/Column'

const CustomDate = ({
  id,
  name,
  ui,
  rowData,
  onUpdateRowData,
  error,
  column,
  handleKeyDown,
  isTable
}) => {
  let { dateFormat } = useTimeFormat()

  let formatType = objectPath.get(ui, 'date.formatType')
  let maskSign = objectPath.get(ui, 'date.maskSign')
  let customFormat = objectPath.get(ui, 'date.format')
  let year = objectPath.get(ui, 'date.year')
  let calendar = year === 543 ? 'BE' : 'BC'
  let value = objectPath.get(rowData, ui.field)
  let date = value ? moment(value).format('YYYY-MM-DD') : null
  let isLockEdit = checkLockMode(column, rowData)
  const formatDate = useMemo(() => {
    if (formatType === 'custom') {
      return customFormat
    }
    return dateFormat
  }, [formatType, customFormat, year])

  const updateData = (date) => {
    let value = null
    if (date?.value) {
      value = moment(date.value).format('YYYY-MM-DD')
    }
    objectPath.set(rowData, ui.field, value)
    onUpdateRowData(rowData)
  }

  return (
    <>
      <DatePickerCustom
        readonly={isLockEdit}
        id={id}
        name={name}
        formatDisplay={formatDate}
        placeholder={formatDate}
        value={date}
        onChange={updateData}
        isClearable={true}
        maskSign={maskSign}
        calendar={calendar}
        error={error}
        style={error ? { borderColor: 'red' } : {}}
        handleKeyDown={(e) => handleKeyDown(e, rowData)}
        isTable={isTable}
      />
    </>
  )
}

export default CustomDate
